import { SettingService } from "@/common/api.service";
import ReferenceService from "@/common/reference.service";
import { 
    FETCH_SETTINGS, 
    CREATE_QUOTE_INSTANCE, 
    UPDATE_FINANCE_PERIOD,
    QUESTIONS_COMPLETE,
    CUSTOMER_DETAILS_COMPLETE,
    COMPLETED_QUOTE,
    RESET_QUOTE
 } from './actions.type';
import { 
    LOADING_START, 
    LOADING_END, 
    SET_SETTINGS, 
    SET_FINANCE_PERIOD,
    SET_QUESTIONS_COMPLETE,
    SET_CUSTOMER_DETAILS_COMPLETE,
    SET_QUOTE_COMPLETE,
    RESET_QUOTE_VARS
 } from './mutations.type';
import ApiService from "../common/api.service";


const state = {
    isDebug: false,
    isLoading: false,
    settings: {},
    calculatorSettings: {
        selectedFinancePeriod: 12
    },
    questionsComplete: false,
    customerDetailsComplete: false,
    quoteComplete: false
}

const getters = {
    isDebug(state) {
        return state.isDebug;
    },
    isLoading(state) {
        return state.isLoading;
    },
    PrimaryColour(state) {
        return state.settings.PrimaryColour;
    },
    Settings(state) {
        return state.settings;
    },
    UsesFinance() {
        return state.settings.IsFinance;
    },
    FinanceSettings(state) {
        return state.settings.FinanceSettings;
    },
    CalculatorSettings(state) {
        return state.calculatorSettings;
    },
    TakeCustomerDetailsFirst(state) {
        return state.settings.TakeCustomersDetailsFirst;
    },
    QuoteComplete(state) {
        return state.questionsComplete && state.customerDetailsComplete;
    }
}

const actions = {
    async [FETCH_SETTINGS]({commit}, payload) {
        return SettingService.get(payload)
            .then(({data}) => {
                commit(SET_SETTINGS, data);
            }) 
    },
    [CREATE_QUOTE_INSTANCE]({ commit, state }) {
        return SettingService.startQuote(state.settings)
            .then(({data}) => {
                commit(SET_SETTINGS, data);
            });
    },
    [UPDATE_FINANCE_PERIOD]({commit}, payload) {
        commit(SET_FINANCE_PERIOD, payload);
    },
    [RESET_QUOTE]({ commit }) {
        commit(RESET_QUOTE_VARS);
    },
    async [QUESTIONS_COMPLETE] ({ commit, dispatch }) {
        await commit(SET_QUESTIONS_COMPLETE);
        dispatch(COMPLETED_QUOTE);
    },
    async [CUSTOMER_DETAILS_COMPLETE] ({ commit, dispatch }) {
        await commit(SET_CUSTOMER_DETAILS_COMPLETE);
        dispatch(COMPLETED_QUOTE);
    },
    [COMPLETED_QUOTE] ({ commit, state }) {
        if (state.questionsComplete && state.customerDetailsComplete) {
            return SettingService.completeQuote()
                .then(() => {
                    commit(SET_QUOTE_COMPLETE);
                })
        }
    }
}

const mutations = {
    [LOADING_START](state) {
        state.isLoading = true;
    },
    [LOADING_END](state) {
        state.isLoading = false;
    },
    [SET_SETTINGS](state, payload) {
        state.settings = payload;
        state.calculatorSettings.selectedFinancePeriod = payload.FinanceSettings.FinancePeriod;
        ReferenceService.saveToken(state.settings.QuoteReference);
        ApiService.setHeader();
    },
    [SET_FINANCE_PERIOD](state, payload) {
        state.calculatorSettings.selectedFinancePeriod = payload;
    },
    [SET_QUESTIONS_COMPLETE] (state) {
        state.questionsComplete = true;
    },
    [SET_CUSTOMER_DETAILS_COMPLETE] (state) {
        state.customerDetailsComplete = true;
    },
    [SET_QUOTE_COMPLETE] (state) {
        state.quoteComplete = true;
    },
    [RESET_QUOTE_VARS] (state) {
        state.questionsComplete = false;
        state.customerDetailsComplete = false;
        state.quoteComplete = false;
    }
}; 


export default {
    state,
    actions,
    mutations,
    getters
}